// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol } from 'mdbreact';
import { localCurrencySettings } from '../../../../../../utils/constans';
import ControlElement from '../../../../ControlElement';
import {calculateFundsRequiredSum} from "../../../../../../utils/calculateFundsRequiredSum";

const FundsInfoSection = ({
  profile,
  amount,
  bidAmountBase,
  quantity,
  basicType,
  variableAmount,
  variablePayAfter,
  maxQuantity,
  hideElements = {},
}) => (

  <>

    <div className="funds_info">
      <div className="info_row">
        <div className="fund_type">Funds Required</div>
        <div className="fund_size">{
            calculateFundsRequiredSum({
              amount: amount || bidAmountBase,
              basicType,
              quantity,
              variableAmount,
              maxQuantity,
              variablePayAfter
            }).toLocaleString('en-US', localCurrencySettings)
          }</div>
      </div>
      <div className="info_row">
        <div className="fund_type">Funds Available</div>
        <div className="fund_size">{
            profile?.balance?.total_balance
                ? (
                  profile?.balance?.total_balance - (profile?.balance?.on_hold || 0)
                ).toLocaleString('en-US', localCurrencySettings)
                : '$0.00'
            }</div>
      </div>
    </div>
  
  </>
);

export default FundsInfoSection;
